module.exports = "<div class=\"loading-popup\" *ngIf=\"_visibility\">\n   <div class=\"loading-popup__header\" *ngIf=\"_message !== '' \">\n      <span>{{_message}}</span>\n   </div>\n   <mat-spinner [diameter]=\"_diameter\" class=\"loading-popup__spinner\"></mat-spinner>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /builds/cp/frap/t3/planer/src/app/core/components/loading-popup/loading-popup.component.html
// module id = ../../../../../src/app/core/components/loading-popup/loading-popup.component.html
// module chunks = main